const privateRequest = store => next => (action) => {
  const { user } = store.getState().global
  if (action.requiredPermission && !user.hasPermission(action.requiredPermission)) {
    return false
  }
  return next(action)
}

export default privateRequest
